import { useSystemAuthState } from "auth/SystemAuth/context/context";
import GovAppBar from "components/GovernmentRfi/GovAppBar";
import Loading from "components/Loading";
import RfiPreviewNav from "components/RfiPreview/RfiPreviewNav";
import { vendorNavPages } from "components/VendorRfi/VendorNav";
import VendorReadOnlyAttachments from "components/VendorRfi/VendorReadOnlyAttachments";
import VendorRfiDetails from "components/VendorRfi/VendorRfiDetails";
import VendorRfiQandA from "components/VendorRfi/VendorRfiQandA";
import VendorRfiQuestionnaire from "components/VendorRfi/VendorRfiQuestionnaire";
import { useRfi } from "hooks/queries";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { useLayoutEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  selectRfi,
  setAttachments,
  setNewElements,
  setRfi,
} from "store/rfiSlice";
import Rfi from "types/Rfi";
import { sectionNames } from "types/RfiTypes";

const stickyNav = () => {
  const navHeight = document.getElementById("main-navbar")?.clientHeight;
  document.body.style.paddingTop = `${(navHeight ?? 159) + 10}px`;
};

const RfiPreview = () => {
  //states
  const [selectedPage, setSelectedPage] = useState(
    vendorNavPages.UNAUTH_DETAILS
  );

  const rfi = useAppSelector(selectRfi);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const source = location.state && location.state.from;
  //Get user info
  const authState = useSystemAuthState();
  const user = authState.user;

  //get rfi id from params
  const { rfiId } = useParams();
  const [selectedVersion, setSelectedVersion] = useState(Number(rfiId));

  const {
    isLoading: isRfiLoading,
    isFetching,
    error,
    data: rfiData,
    remove,
    refetch,
  } = useRfi(selectedVersion, true);

  useLayoutEffect(() => {
    if (rfiData) {
      dispatch(setRfi(new Rfi(rfiData)));

      dispatch(
        setNewElements({
          elements: rfiData.elements,
          section: sectionNames.DESCRIBE,
        })
      );
      dispatch(
        setNewElements({
          elements: rfiData.elements,
          section: sectionNames.VENDOR_INFO,
        })
      );
      dispatch(
        setNewElements({
          elements: rfiData.elements,
          section: sectionNames.QUESTIONNAIRE,
        })
      );
      dispatch(
        setNewElements({
          elements: rfiData.elements,
          section: sectionNames.FINALIZE,
        })
      );
      dispatch(setAttachments(rfiData.attachments));

      document.title = `RFI Preview - ${rfiData?.title ? rfiData.title : ""}`;
    }
  }, [rfiData]);

  useLayoutEffect(() => {    
    stickyNav();
    window.addEventListener("resize", stickyNav);
    return () => window.removeEventListener("resize", stickyNav);
  }, []);

  stickyNav();

  if (!rfi || isRfiLoading) return <Loading />;

  return (
    <>
      <a href="#mainContent" className="visuallyHidden">
        Skip to main content
      </a>

      <div className="fixed-top" id="main-navbar">
        <GovAppBar></GovAppBar>
      </div>
      <div className="container-fluid">
        <div className="row">
          <nav
            id="sidebarMenu"
            className="col-md-4 col-lg-3 d-md-block sidebar pl-md-4 pr-md-0"
          >
            <RfiPreviewNav
              selectedPage={selectedPage}
              setSelectedPage={setSelectedPage}
            />
          </nav>
          <main role="main" className="col-md-8 ml-sm-auto col-lg-9 px-md-4">
            <div
              className="tab-content tile fillHeight"
              id="v-pills-tabContent"
            >
              {selectedPage === vendorNavPages.UNAUTH_DETAILS && (
                <VendorRfiDetails
                 
                  setSelectedPage={setSelectedPage}
                />
              )}
              {selectedPage === vendorNavPages.UNAUTH_ATTACHMENTS && (
                <VendorReadOnlyAttachments
                 
                  setSelectedPage={setSelectedPage}
                />
              )}
              {selectedPage === vendorNavPages.UNAUTH_QUESTIONNAIRE && (
                <VendorRfiQuestionnaire
                 
                  setSelectedPage={setSelectedPage}
                />
              )}
              {selectedPage === vendorNavPages.QA && (
                <VendorRfiQandA
                  setSelectedPage={setSelectedPage}
                 
                />
              )}
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default RfiPreview;
